import Month from '../models/months';
import MonthlyOffer from '../models/monthly-offer';

const offersCollection: MonthlyOffer[] = [
  // ##### TEMPLATE
  // {
  //   month: Month.XX,
  //   year: 2026,
  //   offers: [
  //     {
  //       title: '',
  //       description: '',
  //       imgFile: '.png',
  //       offerPrice: 0.0,
  //     },
  //     {
  //       title: '',
  //       description: '',
  //       imgFile: '.png',
  //       offerPrice: 0.0,
  //     },
  //     {
  //       title: '',
  //       description: '',
  //       imgFile: '.png',
  //       offerPrice: 0.0,
  //     },
  //   ],
  // },
  // #####
  {
    month: Month.February,
    year: 2026,
    offers: [
      {
        title: 'Transpulmin',
        description: 'Erkältungsbalsam, 40 g',
        imgFile: 'transpulmin.png',
        offerPrice: 7.99,
      },
      {
        title: 'Mucosolvan',
        description: 'Hustenlöser, 15 Beutel',
        imgFile: 'mucosolvan.png',
        offerPrice: 7.99,
      },
      {
        title: 'Nasivin Nasenspray',
        description: 'Erwachsene & Schulkinder, 10 ml',
        imgFile: 'nasivin.png',
        offerPrice: 5.99,
      },
    ],
  },
];

export default offersCollection;
